import React from "react";
import { DateTimePicker } from "@mui/x-date-pickers";
import { Typography } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const DateSelector = ({ name, value, error, onPick, views, minDate, label="", dateFormat }) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Typography variant="body1" sx={{mb: 0.5}}>
                {name}
            </Typography>
            {dateFormat && (
                <Typography variant="caption" sx={{
                    color: "text.secondary",
                    fontSize: "0.7rem",
                    display: "block",
                    mb: 0.5
                }}>
                    Format: {dateFormat}
                </Typography>
            )}
            <DateTimePicker
                views={views || ['year', "month", 'day']}
                value={value ? dayjs(value) : null}
                onChange={(newValue) => {
                    onPick(newValue);
                }}
                disablePast={!minDate}
                minDate={minDate || undefined}
                slotProps={{
                    textField: {
                        size: "small",
                        label: label,
                        helperText: (
                            <Typography variant="body2" marginTop={0} color={"error"}>
                                {error || ""}
                            </Typography>
                        ),
                        fullWidth: true,
                        error: !!error
                    }
                }}
            />
        </LocalizationProvider>
    );
};

export default DateSelector;
